export const money = (n) => `₹${Number(n || 0).toLocaleString()}`;
export const pct = (n) => `${(Number(n || 0) * 100).toFixed(1)}%`;

export function parseDate(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function isBetween(dateStr, from, to) {
  const d = parseDate(dateStr);
  if (!d) return true;

  const start = from ? parseDate(from) : null;
  const end = to ? parseDate(to) : null;

  if (start && d < start) return false;
  if (end) {
    const e = new Date(end);
    e.setHours(23, 59, 59, 999);
    if (d > e) return false;
  }
  return true;
}

export function classNames(...x) {
  return x.filter(Boolean).join(" ");
}
